/* Author: Samir Dasarwad
Date: 09/12/2020
*/
<template>
  <div>
    <tl-header type="h1">Levels</tl-header>
    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
      You have only view permission.
    </div>
    <div class="noData" v-show="ifTeamleaderPermission">
      <span class="text">Click on ‘Add New’ to add new Level in the following list</span>
      <button class="addnewbtn" v-if="levelsData.length>3" @click="initCreateForm()">
        <img src="@/assets/group-5.svg" />
        <b>Add New</b>
      </button>
    </div>
    <div :disabled="!(ifTeamleaderPermission)">
      <data-table
        v-show="levelsData ? levelsData.length : false"
        :columns="levelsColumnNames"
        :tableData="levelsData"
        :checkbox="false"
        :withForm="false"
        @editStart="initEditStart"
        @delete="deleteItem"
        :showhistory="false"
      />
    </div>
    <div v-show="ifTeamleaderPermission">
      <form-add-button
        v-show="showAddBtn"
        main_text="+ Add New"
        sub_text="Level"
        v-if="levelsData.length<=3 "
        @click="initCreateForm()"
      />
    </div>
    <pop-up-message
      v-if="showPopup"
      :message="popupMessage"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Delete'"
      :closable="false"
    >

      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
          <popup-btn text="Delete" type="primary" @click="deleteEvent" />
        </btn-grp>
      </template>
    </pop-up-message>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "Levels",
  data() {
    return {
      popupType: "Warning",
      popupMessage: "Are you sure you want to delete ?",
      showPopup: false,
      selectedItem: "",
      levelsColumnNames: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Description",
          key: "description"
        }
      ],
      levelsValue: false,
      role: ""
    };
  },
  mounted() {
    this.fetchAll();
    this.getOrgLeIdList();
  },
  activated() {
    this.fetchAll();
    this.getOrgLeIdList();
  },
  computed: {
    ...mapState("onboard/levels", {
      levelsDataAll: state => state.entityWiseData,
      isFetching: state => state.isFetching,
      isSaving: state => state.isSaving,
      isDeleting: state => state.isDeleting
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    levelsData() {
      return this.levelsDataAll[this.leId];
    },
    showAddBtn() {
      return !this.isFormActive;
    },
    isLoading() {
      return this.isFetching;
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.levelsValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.levelsValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  methods: {
    ...mapActions("onboard/levels/", {
      act_fetchAll: "fetchAll",
      act_delete: "delete",
      act_changeEditMode: "changeEditMode"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /* server call to get levels */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.leId);

      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to go to create levels page */
    async initCreateForm() {
      try {
        await this.act_changeEditMode({ editMode: false, record: {} });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/addLevels`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /* function to go to edit level(create level page) */
    async initEditStart(record) {
      try {
        await this.act_changeEditMode({ editMode: true, record: record });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/modifyLevels`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to hide the pop-up */
    cancelEvent() {
      this.showPopup = false;
    },

    /* function to open the delete confirmation pop-up */
    deleteItem(record) {
      try {
        this.showPopup = true;
        this.selectedItem = record.id;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server to delete level */
    async deleteEvent() {
      try {
        let res = await this.act_delete([this.selectedItem, this.leId]);
        if (res.data.status) {
          this.showPopup = false;
          this.selectedItem = null;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.leId;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.levelsValue = data.data.user.permissions.levels ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
.text {
  height: 54px;
  width: 90%;
  font-family: Montserrat;
  font-size: 14px;
  color: #000000;
}

.noData {
  height: 55px;
  display: flex;
  justify-content: space-between;
  .text {
    color: #858585;
    font-size: 14px;
    margin-top: 20px;
  }
  .addnewbtn {
    float: right;
    b {
      color: #34c0be;
      margin-left: 8px;
    }
  }
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
